import { render, staticRenderFns } from "./level.vue?vue&type=template&id=06d28e26"
import script from "./level.vue?vue&type=script&lang=js"
export * from "./level.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06d28e26')) {
      api.createRecord('06d28e26', component.options)
    } else {
      api.reload('06d28e26', component.options)
    }
    module.hot.accept("./level.vue?vue&type=template&id=06d28e26", function () {
      api.rerender('06d28e26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/list/level.vue"
export default component.exports